import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbImmutableRecord } from "abreact/utils/AbImmutableRecord";
import { Optional } from "abweb/utils/optional/Optional";
import Immutable from "immutable";
// import AbstractOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue;
// import WithoutNodeType = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue.WithoutNodeType;
// import ValidatedExpOperator = Expression.Domain.ValidatedExpOperator;

export class AbstractOperandExpressionNodeConverter {
  constructor(specification) {
    _defineProperty(this, "_specification", void 0);
    this._specification = specification;
  }
  get specification() {
    return this._specification;
  }
  getStateWithoutNodeType(expExpressionNode) {
    return {
      id: expExpressionNode.id,
      description: expExpressionNode.description,
      isEditable: expExpressionNode.editable ?? true,
      isDisabled: expExpressionNode.disabled ?? false,
      expAdditionalDataObject: AbImmutableRecord.State.Object.fromNullable(expExpressionNode.additionalData),
      integrationConfiguration: Optional.of(expExpressionNode.integrationConfiguration).map(Immutable.Map).get()
    };
  }
}
//# sourceMappingURL=AbstractOperandExpressionNodeConverter.js.map
